import { gql } from 'graphql-tag';
import { baseResponseGraphqlField } from '../../../base.graphql';

export const aboutUsFields = `
  id
  uniqueId
  content
`;

export const CREATE_ABOUT_US = gql`
  mutation CreateAboutUsMutation($input: AboutUsInputObject!) {
    createAboutUsMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${aboutUsFields}
      }
    }
  }
`;

export const UPDATE_ABOUT_US = gql`
  mutation UpdateAboutUsMutation($input: AboutUsInputObject!) {
    updateAboutUsMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${aboutUsFields}
      }
    }
  }
`;

export const GET_ABOUT_US = gql`
  query GetAboutUs($filtering: AboutUsFilteringInputObject) {
    getAboutUs(filtering: $filtering) {
      ${baseResponseGraphqlField}
      data {
        ${aboutUsFields}
      }
    }
  }
`;
